import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eb492982"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pa-8" }
const _hoisted_2 = { class: "d-flex justify-space-between align-center" }
const _hoisted_3 = { class: "d-flex align-center" }

import { withDefaults, ref, watch } from 'vue';
import { AtomSubTitle, AtomTitle } from '../atoms';
import * as comps from '@/components/atoms';

interface IProps {
  show: any;
  disabled?: boolean;
  width?: string;
  icon?: string;
  iconColor?: string;
  el?: any;
  title: string;
  subtitle?: string;
  btnCloseText?: string;
  btnConfirmText?: string;
  paddingY?: string;
  btnConfitmDisabled?: boolean;
  hasBtnClose?: boolean;
  hasBtnConfirm?: boolean;
  hasFooter?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeModal',
  props: {
    show: null,
    disabled: { type: Boolean, default: false },
    width: { default: '477px' },
    icon: null,
    iconColor: null,
    el: { default: 'div' },
    title: null,
    subtitle: null,
    btnCloseText: { default: 'Cancelar' },
    btnConfirmText: { default: 'Importar' },
    paddingY: { default: '0px' },
    btnConfitmDisabled: { type: Boolean },
    hasBtnClose: { type: Boolean, default: true },
    hasBtnConfirm: { type: Boolean, default: true },
    hasFooter: { type: Boolean, default: true }
  },
  emits: ['handleCancel', 'handleConfirm'],
  setup(__props: any, { emit }) {

const props = __props as { show: any, disabled: boolean, width: string, icon?: string, iconColor?: string, el: any, title: string, subtitle?: string, btnCloseText: string, btnConfirmText: string, paddingY: string, btnConfitmDisabled?: boolean, hasBtnClose: boolean, hasBtnConfirm: boolean, hasFooter: boolean };





const dialog = ref<boolean>(false);

function handleConf() {
  return props.el !== 'form' ? handleConfirm() : '';
}
function handleCancel() {
  emit('handleCancel');
}
function handleConfirm() {
  emit('handleConfirm');
}

function close() {
  emit('handleCancel', 'fecha');
}

watch(
  () => props.show,
  () => (dialog.value = props.show)
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
    persistent: "",
    width: props.width
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(props.el), {
        class: "modal-area",
        onSubmit: _withModifiers(handleConfirm, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (props.icon)
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(comps[props.icon]), {
                      key: 0,
                      color: props.iconColor,
                      class: "mr-2"
                    }, null, 8, ["color"]))
                  : _createCommentVNode("", true),
                _createVNode(_unref(AtomTitle), {
                  title: props.title,
                  classes: ['title-modal mb-0']
                }, null, 8, ["title"])
              ]),
              _createVNode(_component_v_btn, {
                icon: "",
                dark: "",
                size: "small",
                onClick: close,
                class: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-close")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", {
            class: "body-modal pb-6",
            style: _normalizeStyle({ padding: `${props.paddingY ? props.paddingY : '32px'} 32px` })
          }, [
            _renderSlot(_ctx.$slots, "body")
          ], 4),
          _createVNode(_component_v_divider),
          (__props.hasFooter)
            ? (_openBlock(), _createBlock(_component_v_footer, {
                key: 0,
                class: "d-flex justify-end pa-0 pa-8 rounded-xl",
                style: {"gap":"16px"}
              }, {
                default: _withCtx(() => [
                  (!__props.disabled && __props.hasBtnClose)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        onClick: handleCancel,
                        class: "btn-footer"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.btnCloseText), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!__props.disabled && __props.hasBtnConfirm)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        disabled: __props.btnConfitmDisabled ?? false,
                        onClick: handleConf,
                        type: "submit",
                        class: "bg-primary btn-footer"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.btnConfirmText), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }, 40, ["onSubmit"]))
    ]),
    _: 3
  }, 8, ["modelValue", "width"]))
}
}

})